







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Gender,
  LayoutStyle,
  QuestionInput,
  QuestionType,
  SelectListOption
} from "@/model/Model";
import { Borough } from "@/model/Boroughs";
import { IBlobStream } from "blob-stream";
import SelectList from "@/components/SelectList.vue";
import { LogEvent } from "@/utils";
import { UserInteractionEvent } from "@/model/UserEvents";

const scenarioOptions = [
  { label: "IF I am really happy..." },
  { label: "IF things are not going my way and I am frustrated..." },
  { label: "IF I am out with others who are drinking a lot..." },
  { label: "IF other people encourage me to have a drink..." },
  { label: "IF I am offered a drink by someone..." },
  { label: "IF I am feeling depressed..." },
  { label: "IF I am having fun with friends..." },
  { label: "IF my friends push me to keep up with their drinking..." },
  { label: "IF I am feeling shy..." }
];

const actionOptions = [
  { label: "...THEN I will have several alcohol-free days each week" },
  {
    label:
      "...THEN I will download the free DrinkCoach app to track drinking and set goals: " +
      '<a href="http://drinkcoach.org.uk" target="_blank">drinkcoach.org.uk</a>'
  },
  {
    label:
      "...THEN I will plan activities and tasks at those times I usually drink"
  },
  {
    label:
      "...THEN I will explore other interests, such as cinema, theatre, art, and music"
  },
  { label: "...THEN I will have a workout or exercise" },
  { label: "...THEN I will avoid going to the pub" },
  { label: "...THEN I will have my first drink after starting to eat" },
  {
    label:
      "...THEN I will quench my thirst with non-alcohol drinks before and between alcoholic drinks"
  },
  { label: "...THEN I will avoid drinking in rounds or large groups" },
  {
    label: "...THEN I will switch to lower strength (i.e. from 5% to 4%) drinks"
  },
  { label: "...THEN I will set myself a limit and stick to it" },
  {
    label:
      '...THEN I will avoid or limit time spent with "heavy" drinking friends'
  }
];

const SCENARIOS: QuestionInput[] = [
  {
    kind: QuestionType.Select,
    label: "SCENARIO 1 -<br>IF this happens...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...scenarioOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  },
  {
    kind: QuestionType.Select,
    label: "SCENARIO 2 -<br>IF this happens...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...scenarioOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  },
  {
    kind: QuestionType.Select,
    label: "SCENARIO 3 -<br>IF this happens...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...scenarioOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  }
];

const ACTIONS: QuestionInput[] = [
  {
    kind: QuestionType.Select,
    label: "PLAN 1 -<br>THEN I will...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...actionOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  },
  {
    kind: QuestionType.Select,
    label: "PLAN 2 -<br>THEN I will...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...actionOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  },
  {
    kind: QuestionType.Select,
    label: "PLAN 3 -<br>THEN I will...",
    selected: null,
    required: false,
    layoutStyle: LayoutStyle.SingleColumn,
    options: [
      ...actionOptions,
      {
        label: "Create your own",
        editable: true
      }
    ]
  }
];

const pdfkitSrc = "/static/pdfkit.js";
const blobStreamSrc = "/static/blob-stream.js";
@Component({
  components: { SelectList }
})
export default class CreateAPlan extends Vue {
  public static navButtonClasses: string[] = ["create-a-plan"];
  public static navButtonLabel: () => string = () => "Create a plan";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private numLoaded = 0;
  private isPlanCompleted: boolean = false;
  private emailInputPending: boolean = false;
  private sentEmail: boolean = false;
  private emailAddress: string = "";
  private emailError: string = "";
  private emailSending: boolean = false;
  private tab: Window | null = null;
  private getPDF:
    | ((plan: Array<{ scenario: string; action: string }>) => IBlobStream)
    | null = null;

  private fetchPDFThenPrint(event: Event) {
    this.createNewWindow();
    if (this.pdfScriptsLoaded(this.scriptAssetsLoadedForPrint.bind(this))) {
      this.saveOrPrintPDF(true);
    }
  }

  private scenarios(index: number): QuestionInput {
    return SCENARIOS[index - 1];
  }

  private actionItems(index: number): QuestionInput {
    return ACTIONS[index - 1];
  }

  private get emailNotSet(): boolean {
    return this.emailAddress.split(" ").join("").length === 0;
  }

  private get hasEmailError(): boolean {
    return this.emailError !== "";
  }

  private onCustomInputChange() {
    this.isPlanCompleted = this.planCompleted();
  }

  private sendEmailIfEmailIsValid(event: KeyboardEvent) {
    (event.currentTarget as HTMLInputElement).blur();
    if (!this.emailIsInvalid) {
      this.fetchPDFThenEmail(event);
    }
  }

  private get emailIsInvalid(): boolean {
    return this.emailAddress.indexOf("@") === -1;
  }

  private get showEmailField(): boolean {
    return this.emailInputPending;
  }

  private showHideEmailField() {
    this.emailInputPending = !this.emailInputPending;
  }

  private emailPDF() {
    const isLocal = window.location.href.indexOf("localhost") !== -1;
    const isStaging =
      window.location.href.indexOf("staging.drinkcoach.org.uk") !== -1;
    const isProd =
      window.location.href.indexOf("audit.drinkcoach.org.uk") !== -1;
    let apiRoot = "";
    if (isStaging) {
      apiRoot = "https://staging.drinkcoach.org.uk";
    } else if (isProd) {
      apiRoot = "https://audit.drinkcoach.org.uk";
    }
    const email = () => {
      const stream = (this.getPDF as (
        p: Array<{ scenario: string; action: string }>
      ) => IBlobStream)(this.plan());
      stream.on("finish", () => {
        const reader = new FileReader();
        const blob = stream.toBlob("application/pdf");
        reader.addEventListener("loadend", () => {
          // Do something with reader.result
          const data = new FormData();
          data.append("content", reader.result as string);
          data.append("email", this.emailAddress);
          fetch(`${apiRoot}/api/send-email.php`, {
            method: "POST",
            body: data
          }).then(
            response => {
              response.json().then((r: { success: boolean; error: string }) => {
                if (r.success) {
                  this.emailAddress = "";
                  this.sentEmail = true;
                  setTimeout(() => {
                    this.sentEmail = false;
                  }, 3000);
                } else {
                  this.emailError = r.error;
                  console.log(r.error);
                }
              });
              this.emailSending = false;
            },
            error => {
              console.log(error);
              this.emailError = error;
              this.emailSending = false;
            }
          );
        });
        reader.readAsDataURL(blob);
      });

      stream.on("error", () => {
        // TODO(jon):
      });
    };

    if (!this.getPDF) {
      import("@/create-pdf").then(({ getPDF }) => {
        this.getPDF = getPDF;
        email();
      });
    } else {
      email();
    }
  }

  private scriptAssetsLoadedForEmail(event: Event) {
    this.numLoaded++;
    if (this.numLoaded === 2) {
      this.emailPDF();
    }
  }

  private scriptAssetsLoadedForSave(event: Event) {
    this.numLoaded++;
    if (this.numLoaded === 2) {
      this.saveOrPrintPDF(false);
    }
  }

  private scriptAssetsLoadedForPrint(event: Event) {
    this.numLoaded++;
    if (this.numLoaded === 2) {
      this.saveOrPrintPDF(true);
    }
  }

  private pdfScriptsLoaded(callback: any): boolean {
    const existingScripts = document.querySelectorAll("script") as NodeListOf<
      HTMLScriptElement
    >;
    let scriptsLoaded = false;
    for (const script of existingScripts) {
      if (
        script.src.endsWith(pdfkitSrc) ||
        script.src.endsWith(blobStreamSrc)
      ) {
        scriptsLoaded = true;
      }
    }
    if (!scriptsLoaded) {
      // Load scripts
      const pdfKitScriptEl = document.createElement(
        "script"
      ) as HTMLScriptElement;
      const blobStreamScriptEl = document.createElement(
        "script"
      ) as HTMLScriptElement;
      pdfKitScriptEl.src = pdfkitSrc;
      blobStreamScriptEl.src = blobStreamSrc;
      pdfKitScriptEl.onload = callback;
      blobStreamScriptEl.onload = callback;
      document.body.appendChild(pdfKitScriptEl);
      document.body.appendChild(blobStreamScriptEl);
    }
    return scriptsLoaded;
  }

  private fetchPDFThenEmail(event: Event) {
    this.emailSending = true;
    this.emailError = "";
    if (this.pdfScriptsLoaded(this.scriptAssetsLoadedForEmail.bind(this))) {
      this.emailPDF();
    }
  }

  private saveOrPrintPDF(shouldPrint: boolean = false) {
    const saveOrPrint = () => {
      const stream = (this.getPDF as (
        p: Array<{ scenario: string; action: string }>
      ) => IBlobStream)(this.plan());
      stream.on("finish", () => {
        if (this.tab !== null) {
          (this.tab as Window).location.href = stream.toBlobURL(
            "application/pdf"
          );
          if (shouldPrint) {
            setTimeout(() => {
              if (this.tab !== null) {
                (this.tab as Window).print();
              }
            }, 1000);
          }
        }
      });

      stream.on("error", () => {
        // TODO(jon):
      });
    };

    if (this.getPDF === null) {
      import("@/create-pdf").then(({ getPDF }) => {
        this.getPDF = getPDF;
        saveOrPrint();
      });
    } else {
      saveOrPrint();
    }
  }

  private createNewWindow() {
    this.tab = window.open("", "_blank") as Window;
    this.tab.document.open();
    this.tab.document.write("Creating your PDF, please wait...");
    this.tab.document.close();
  }

  private fetchPDF(event: Event) {
    this.createNewWindow();
    if (this.pdfScriptsLoaded(this.scriptAssetsLoadedForSave.bind(this))) {
      this.saveOrPrintPDF(false);
    }
  }

  private planCompleted(): boolean {
    return this.plan().length >= 1;
  }

  private onSelectedItem(item: SelectListOption) {
    const completed = this.planCompleted();
    if (!this.isPlanCompleted && completed) {
      LogEvent(UserInteractionEvent.PlanCreated);
    }
    this.isPlanCompleted = completed;
  }

  private plan(): Array<{ scenario: string; action: string }> {
    const allScenarios = [];
    for (let i = 0; i < 3; i++) {
      const scenario = SCENARIOS[i];
      const action = ACTIONS[i];
      if (scenario.selected !== null && action.selected !== null) {
        const selectedScenario = scenario.selected as SelectListOption;
        const selectedAction = action.selected as SelectListOption;
        let scenarioLabel = selectedScenario.label;
        let actionLabel = selectedAction.label;
        if (selectedScenario.editable) {
          scenarioLabel = selectedScenario.editedText as string;
        }
        if (selectedAction.editable) {
          actionLabel = selectedAction.editedText as string;
        }
        actionLabel = actionLabel.replace(
          '<a href="http://drinkcoach.org.uk" target="_blank">drinkcoach.org.uk</a>',
          "drinkcoach.org.uk"
        );
        if (
          scenarioLabel.split(" ").join("").length > 0 &&
          actionLabel.split(" ").join("").length > 0
        ) {
          allScenarios.push({
            scenario: scenarioLabel,
            action: actionLabel
          });
        }
      }
    }
    return allScenarios;
  }
}
